exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#zc__bubble_container{display:none}.oneMinuteText{font-size:14px;font-weight:400;color:rgba(0,0,0,.65);letter-spacing:1px}", ""]);

// exports
